import { render, staticRenderFns } from "./SCardExpenseComp.vue?vue&type=template&id=d4b572c6&"
import script from "./SCardExpenseComp.vue?vue&type=script&lang=js&"
export * from "./SCardExpenseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports